import accordian from "./accordian"

const feqAccordian = {
  accordianCont: document.querySelectorAll(".frequently-asked-questions") as NodeListOf<HTMLElement>,

  init() {
    this.toggle()
  },

  toggle() {
    this.accordianCont.forEach((acc) => {
      const list = Array.from(acc.children) as HTMLElement[]   
      list.forEach((item) => {
        const trigger = item.firstElementChild as HTMLElement
        const sibiling = item.lastElementChild as HTMLElement
        trigger.dataset.open = "false"
        accordian.toggleHeight(trigger, item, sibiling)
      })
    })
  },
}

export default feqAccordian
